export enum NotificationMode {
  SHOW_MESSAGE = "show_message",
  SEND_MESSAGE = "send_message",
}
